import { knownProducts, isProductEnabled } from './products.js';

// Add actual production or staging aliases here.
export const appDomains = Object.freeze({
  'app.signitic.com': 'signitic',
  'app.user.com': 'user',
  'app.surferseo.com': 'surfer',
  'app.iconosquare.com': 'iconosquare',
  'app.humanlinker.com': 'humanlinker',
  'app.getubic.com': 'ubic',
  'nocrm.io': 'nocrm',
  '4dem.it': '4dem',
  'mailingwork.de': 'mailingwork',
  'rapidmail.fr': 'rapidmail',
});

// noCRM uses one subdomain per account: company.nocrm.io.
export const tenantDomains = Object.freeze([
  Object.freeze({
    domain: 'nocrm.io',
    productId: 'nocrm',
    excludedSubdomains: Object.freeze(['www', 'register', 'help', 'support', 'api', 'status']),
  }),
]);

// These aliases are recognized only during Vite development.
export const developmentDomains = Object.freeze(Object.fromEntries(
  knownProducts.filter(({ id }) => isProductEnabled(id)).map(({ id }) => [`${id}.localhost`, id]),
));
